import RadioButtonQuest from "../../../../UI/RadioButtonQuest";
import pound from "../../../../../assets/UFC_DC_V1/img/pound.png";

const Question114 = ({ clsName, onSelectAnswer, selectedBank, prevQuestion, btnDisable, bacKbtnId }) => {
  const optionHandle = (e) => {
    onSelectAnswer(e);
  };

  const handleBack = () => {
    prevQuestion("question114");
  };

  return (
    <div className={`swiper-slide slide-up-now ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        {`Would you like to run a free, online scan to calculate the estimated refund from ${
          selectedBank ? selectedBank : ""
        } for this overdraft facility? `}
      </h2>
      <div className="ms-lg-5 ms-md-3 ms-0 ps-lg-4 ps-md-3 ps-sm-2 ps-0 pt-lg-2 pt-md-4 pt-sm-2 pt-2 below-text slide-up-now">
        <div className="mt-2 d-flex align-items-center">
          <div className="me-3">
            <img height="25" src={pound} alt="" />
          </div>

          <div>
            {" "}
            Our Highest Overdraft Refund is - <strong>£3,024</strong>
          </div>
        </div>
        <div className="mt-3 d-flex align-items-center slide-up-now">
          <div className="me-3">
            <img height="25" src={pound} alt="" />
          </div>
          <div>
            {" "}
            Our Average Overdraft Refund is - <strong> £993</strong>
          </div>
        </div>
      </div>
      <ul className="btn-option optinal-items two-options slide-up-now">
        <li>
          <div className="option_but">
            <RadioButtonQuest
              key="q114_1"
              className="radio"
              labelName="Yes"
              labelClassName="align-items-center btn-next"
              onClick={optionHandle}
              value="318"
              name="question114"
              id="318"
              dataQuestId={114}
              dataAnsId={318}
            />
          </div>
        </li>

        <li>
          <div className="option_but btn-next">
            <RadioButtonQuest
              key="q114_2"
              className="radio"
              labelName="No"
              labelClassName=""
              onClick={optionHandle}
              value="319"
              name="question114"
              id="319"
              dataQuestId={114}
              dataAnsId={319}
            />
          </div>
        </li>
      </ul>
      <div className="mt-2 mb-4 text-center">
        <div>
          {" "}
          <button
            className={`back-btn mainbckBtn bi bi-chevron-left ${btnDisable ? 'hide' : ''}`}
            type="button"
            onClick={handleBack}
            disabled={btnDisable}
          >
            Back
          </button>{" "}
        </div>
      </div>
    </div>
  );
};

export default Question114;
